import React, { useState, useEffect } from "react";
import { useDispatch } from 'react-redux'
import allActions from "../../store/redux-actions";
import Services from "../../services";
const QuyenTruyCapModal = ({roleConfig}) => {

    //khoi tao service
    const quyenTruyCapService=Services.getQuyenTruyCapService();
    const quyenTruyCapAdminService=Services.getQuyenTruyCapAdminService();
    const [listQuyen, setListQuyen] = useState([]);
    const dispatch = useDispatch()
    var isMounted=true;
    useEffect(() => { 
        isMounted = true;  
        quyenTruyCapService.getAll(["ALL",roleConfig]).then( 
            (response) => {
                if (response.data != null) {
                    if(isMounted){
                        setListQuyen(response.data)
                    }
                }
            },
            (error) => {
               
            }
        );

        return () => { isMounted = false };
    },[]);
    function Luu(){
        if(window.confirm("Bạn có chắc muốn cập nhật quyền này ")){
            quyenTruyCapAdminService.saveQuyen(roleConfig,listQuyen).then(
                (response) => {
                    if (response.data != null) {
                       
                        dispatch(allActions.displayModalActions.setDisplay(null))
                    }
                },
                (error) => {
                    
                }
            );
        }
        
    }
    function updateList(quyen,index,enable){
        let newArr = [...listQuyen]
        newArr[index] = {...quyen,"enable":enable};
        setListQuyen(newArr);

    }
    function getlabel(role){
        switch(role){
            case "ROLE_QUANTRI": {return "QUẢN TRỊ"}
            case "ROLE_LANHDAO": {return "LÃNH ĐẠO"}
            case "ROLE_QUANLY": {return "QUẢN LÝ"}
            case "ROLE_NHANVIEN": {return "NHÂN VIÊN"}
            case "ROLE_TRUONGPHONG": {return "TRƯỞNG PHÒNG"}
        }
    }
  return (
    <div className="modal" id="exampleModal" aria-labelledby="exampleModalLabel" aria-hidden="true" >
        <div className="modal-dialog modal-md">
            <div className="modal-content">
                <div className="modal-header">
                <h5 className="modal-title">CÀI ĐẶT QUYỀN CHO {getlabel(roleConfig)}</h5>
                <button type="button" className="close" data-dismiss="modal"  onClick={(e) => { dispatch(allActions.displayModalActions.setDisplay(null))}}>×</button>
                
                </div>
                <div className="modal-body">
                 
                    <div className="row"style={{overflowX:"auto",overflowY: "scroll",height:"calc(100vh - 250px)",paddingLeft: "20px"}}>
                        <div style={{width:"95%",border:"10px"}}>
                        
                            {listQuyen.map((item,index)=>
                            
                                <div key = {item.url} className="tr-quyentruycap flex">
                                     <div> <span className="ps-2 form-check form-switch flex">
                                            <input className="form-check-input" type="checkbox" defaultChecked={item.enable} onChange={(e)=>{updateList(item,index,e.target.checked)}}/>
                                        </span>
                                    </div>
                                    <div ><h5 className="form-check-label ps-3" >{item.name}</h5></div>
                                   
                                </div>
                            )}
                           
                            
                          
                        </div>

                    </div>
                            
                   
                </div>
                <div className="modal-footer">
                    
                    <button onClick={(e)=>{Luu()}} className="btn btn-primary me-1 btn-luu">Lưu</button>
                    <button type="button" className="btn btn-light" data-dismiss="modal" onClick={(e) => { dispatch(allActions.displayModalActions.setDisplay(null))}}>Thoát</button>
                </div>
            </div>
        </div>       
  </div>
    );
    };
  
  export default QuyenTruyCapModal;